import _ from 'lodash';

const HelperTime = {
	
	/**
	 *
	 * @param segments
	 * @returns {boolean}
	 */
	checkOverlap: ( segments ) => {
		// Only one segment? Then it does not overlap
		if (segments.length === 1) {
			return false;
		}
		
		// Sort the times
		segments.sort( ( timeSegment1, timeSegment2 ) =>
			{
			return timeSegment1[0].localeCompare(timeSegment2[0]);
		}
		);
		
		// Compare
		for( let i = 0; i < segments.length - 1; i++ ) {
			const currentEndTime = segments[i][1];
			const nextStartTime = segments[i + 1][0];
			
			if (currentEndTime > nextStartTime) {
				return true;
			}
		}
		
		return false;
	},
	
	createSegments: ( ...collection ) => {
		const segments = [];
		_.forEach( collection, items => {
			if( !Array.isArray( items ) ) {
				items = [ items ];
			}
			
			_.forEach( items, obj => {
				segments.push(
					HelperTime.createSegment( obj )
				)
			})
		});
		
		return segments;
	},
	
	createSegment: ( obj ) => {
		return [
			obj.timeslot.timeslot_start,
			obj.timeslot.timeslot_end
		]
	}
}

export default HelperTime
